import { useModal } from '@shared/model/useModal';

export const useFullscreenVideoModal = () => useModal('full-screen')